export default __webpack_public_path__ + "static/cafe_36055-49a35bf93d17706617b987c6a2f570a4.png";